import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import CreativeImage from "./CreativeImage";
import { writeBatch, doc, collection, getDocs } from "firebase/firestore";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import { db, storage, app } from "../firebase";

import axios from "axios";
import cheerio from "cheerio";
export default function Institutions() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page2, setPage2] = useState(0);
  const [rowsPerPage2, setRowsPerPage2] = useState(5);
  const [page3, setPage3] = useState(0);
  const [rowsPerPage3, setRowsPerPage3] = useState(5);
  const [page4, setPage4] = useState(0);
  const [rowsPerPage4, setRowsPerPage4] = useState(5);
  const [page5, setPage5] = useState(0);
  const [rowsPerPage5, setRowsPerPage5] = useState(5);
  const [rows, setRows] = useState([]);
  const [rows2, setRows2] = useState([]);
  const [rows3, setRows3] = useState([]);
  const [items, setItems] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage2 = (event, newPage) => {
    setPage2(newPage);
  };

  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage2(parseInt(event.target.value, 10));
    setPage2(0);
  };
  const handleChangePage3 = (event, newPage) => {
    setPage3(newPage);
  };

  const handleChangeRowsPerPage3 = (event) => {
    setRowsPerPage3(parseInt(event.target.value, 10));
    setPage3(0);
  };
  const handleChangePage4 = (event, newPage) => {
    setPage4(newPage);
  };

  const handleChangeRowsPerPage4 = (event) => {
    setRowsPerPage4(parseInt(event.target.value, 10));
    setPage4(0);
  };
  const handleChangePage5 = (event, newPage) => {
    setPage5(newPage);
  };

  const handleChangeRowsPerPage5 = (event) => {
    setRowsPerPage5(parseInt(event.target.value, 10));
    setPage5(0);
  };

  const fetchHeadsOfState = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "headsofstate"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const sort = treaties.sort((a, b) => a.name.localeCompare(b.name));
      setHeadsOfState(sort);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  const fetchHeadsOfGovernment = async () => {
    // try {
    //   const targetUrl =
    //     " https://en.wikipedia.org/wiki/Category:Heads_of_government_by_country";
    //   const response = await axios.get(targetUrl);
    //   const html = response.data;
    //   const $ = cheerio.load(html);
    //   const extractedHeads = [];
    //   $(".mw-category-group ul li").each((i, element) => {
    //     // Skip the first anchor (CategoryTreeToggle) and select the second one which is the actual link
    //     const anchors = $(element).find("a");
    //     const correctAnchor = anchors
    //       .filter((j, el) => {
    //         return !$(el).hasClass("CategoryTreeToggle");
    //       })
    //       .first();
    //     const href = correctAnchor.attr("href");
    //     const headName = correctAnchor.text().trim();
    //     // Ensure the href attribute exists and prepend the base URL
    //     if (href && href.startsWith("/wiki")) {
    //       const headLink = `https://en.wikipedia.org${href}`;
    //       extractedHeads.push({ name: headName, link: headLink });
    //     } else {
    //       console.log("Skipped or Invalid href for:", headName);
    //     }
    //   });
    //   //   const fetched = extractedHeads.filter(
    //   //     (row) => row.link !== "https://en.wikipedia.orgundefined"
    //   //   );
    //   setHeadsOfGovernment(extractedHeads);
    //   console.log(extractedHeads, "branchesOfGov");
    // } catch (error) {
    //   console.error("Failed to fetch heads of government:", error);
    // }
    try {
      const querySnapshot = await getDocs(collection(db, "headsofgovernment"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setHeadsOfGovernment(treaties);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  const fetchBranchesofGov = async () => {
    try {
      const querySnapshot = await getDocs(
        collection(db, "executivebanchesofgov")
      );
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBranchesOfGov(treaties);

      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  useEffect(() => {
    // const batch = writeBatch(db); // Create a batch write object
    // headsOfGovernment.forEach((treatyData) => {
    //   const newDocRef = doc(collection(db, "headsofgovernment")); // Create a new document reference in the "treaties" collection
    //   batch.set(newDocRef, treatyData); // Add data to the batch
    // });
    // batch.commit(); // Commit the batch
    console.log("Data written to Firestore");
  }, []);
  const fetchMinistry = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "ministrybycountry"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const sort = treaties.sort((a, b) => a.name.localeCompare(b.name));

      setMinistry(sort);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  const [mayors, setMayors] = useState([]);
  const [headsOfState, setHeadsOfState] = useState([]);
  const [headsOfGovernment, setHeadsOfGovernment] = useState([]);
  const [branchesOfGov, setBranchesOfGov] = useState([]);
  const [ministry, setMinistry] = useState([]);

  useEffect(() => {
    fetchMayors();
    fetchMinistry();
    fetchHeadsOfState();
    fetchBranchesofGov();
    fetchHeadsOfGovernment();
  }, []);
  const fetchMayors = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "listofmayors"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMayors(treaties);

      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,

        backgroundColor: "#212C62",
      }}
    >
      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>Institutions</b>
            </h1>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>Heads of state by country : </b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {headsOfState
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <a className="colorst" target="_blank" href={row.link}>
                          {row.name}
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={headsOfState.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <div className="mt-5">
          <h5 style={{ color: "212C62" }}>
            <b>Heads of government by country</b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {headsOfGovernment
                  .slice(
                    page2 * rowsPerPage2,
                    page2 * rowsPerPage2 + rowsPerPage2
                  )
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <a className="colorst" target="_blank" href={row.link}>
                          {row.name}
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={headsOfGovernment.length}
            rowsPerPage={rowsPerPage2}
            page={page2}
            onPageChange={handleChangePage2}
            onRowsPerPageChange={handleChangeRowsPerPage2}
          />
        </Paper>
        <div className="mt-5">
          <h5 style={{ color: "212C62" }}>
            <b>Executive branches of government by country:</b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {branchesOfGov
                  .slice(
                    page3 * rowsPerPage3,
                    page3 * rowsPerPage3 + rowsPerPage3
                  )
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">
                        <a className="colorst" target="_blank" href={row.link}>
                          {row.name}
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={branchesOfGov.length}
            rowsPerPage={rowsPerPage3}
            page={page3}
            onPageChange={handleChangePage3}
            onRowsPerPageChange={handleChangeRowsPerPage3}
          />
        </Paper>
        <div className="mt-5">
          <h5 style={{ color: "212C62" }}>
            <b>Ministries by country:</b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ministry
                  .slice(
                    page4 * rowsPerPage4,
                    page4 * rowsPerPage4 + rowsPerPage4
                  )
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">
                        <a className="colorst" target="_blank" href={row.link}>
                          {row.name}
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={ministry.length}
            rowsPerPage={rowsPerPage4}
            page={page4}
            onPageChange={handleChangePage4}
            onRowsPerPageChange={handleChangeRowsPerPage4}
          />
        </Paper>
        <div className="mt-5">
          <h5 style={{ color: "212C62" }}>
            <b>List of Mayors by country:</b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mayors
                  .slice(
                    page5 * rowsPerPage5,
                    page5 * rowsPerPage5 + rowsPerPage5
                  )
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="left">
                        <a className="colorst" target="_blank" href={row.link}>
                          {row.name}
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={mayors.length}
            rowsPerPage={rowsPerPage5}
            page={page5}
            onPageChange={handleChangePage5}
            onRowsPerPageChange={handleChangeRowsPerPage5}
          />
        </Paper>
      </Card>
    </div>
  );
}
